import { configureStore } from '@reduxjs/toolkit';
import authReducer, { logout as authLogout } from './slices/authSlice';
import reportReducer from './slices/reportSlice';
import orgMapReducer, { resetOrg as resetOrgMap } from './slices/orgMap';
import designReducer from './slices/designSlice';
import orgReducer, { reset as resetOrgs } from './slices/orgs';
import { orgHooks } from './apis/org';
import { authHooks } from './apis/auth';
import { systemHooks } from './apis/system';
import { cutStateHooks } from './apis/cutState';
import { ticketsHooks } from './apis/tickets';
import { cutHooks } from './apis/cut';

export const store = configureStore({
    reducer: {
        [orgHooks.reducerPath]: orgHooks.reducer,
        [authHooks.reducerPath]: authHooks.reducer,
        [systemHooks.reducerPath]: systemHooks.reducer,
        [cutStateHooks.reducerPath]: cutStateHooks.reducer,
        [ticketsHooks.reducerPath]: ticketsHooks.reducer,
        [cutHooks.reducerPath]: cutHooks.reducer,
        auth: authReducer,
        report: reportReducer,
        orgMap: orgMapReducer,
        design: designReducer,
        orgs: orgReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
            immutableCheck: false,
            thunk: true,
        })
            .concat(orgHooks.middleware)
            .concat(authHooks.middleware)
            .concat(systemHooks.middleware)
            .concat(cutStateHooks.middleware)
            .concat(ticketsHooks.middleware)
            .concat(cutHooks.middleware),
});

/**
 * Clear the store on logout.
 */
export const logout = () => {
    store.dispatch(authLogout());
    store.dispatch(resetOrgMap());
    store.dispatch(resetOrgs());
};

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
